import {isBefore} from 'date-fns';

const Utils = {

    cartesianToDegrees(cartesianArray, cesium) {
        let result = []
        for (let i = 0; i <= cartesianArray.length - 3; i += 3) {
            const element = cartesianArray[i];
            const cart = cesium.Cartographic.fromCartesian({
                x: element,
                y: cartesianArray[i + 1],
                z: cartesianArray[i + 2]
            });
            result.push({
                lon: cart.longitude * (180 / Math.PI),
                lat: cart.latitude * (180 / Math.PI),
                alt: cart.height
            });
        }
        return result;
    },
    createMark(mark, event, cesium, viewer) {
        let coordinate = cesium.Cartographic.fromCartesian(mark.position.getValue(viewer.clock.currentTime));
        let entity = {
            id: this.isTemporaryIndex(mark.id) ? null : mark.id,
            name: mark.name,
            label: mark.name,
            //device: {id:},
            event: event,
            fixed: true,
            latitude: cesium.Math.toDegrees(coordinate.latitude),
            longitude: cesium.Math.toDegrees(coordinate.longitude),
            deleted: false,
            sportClass: mark.sportClass
        };
        //this.updateEntityModel(entity, mark.sportClass, cesium);
        return entity;
    },
    createWayPoint(wayPoint, event, cesium, viewer) {
        let newWayPoint = {
            id: this.isTemporaryIndex(wayPoint.id) ? null : wayPoint.id,
            event: event,
            name: wayPoint.name,
            deleted: false,
            label: wayPoint.name,
            leaveMarkSide: wayPoint.leaveMarkSide
        };
        //Creame mark1
        newWayPoint.mark1 = this.createMark(wayPoint.mark1, event, cesium, viewer);
        if (wayPoint.mark2 != undefined) {
            //Creame mark2
            newWayPoint.mark2 = this.createMark(wayPoint.mark2, event, cesium, viewer);
        }
        return newWayPoint;
    },
    createRace(id, name, type, status, trackStart, trackEnd, raceStart, event, entrys, distance) {
        let race = {
            name: name,
            event: event,
            status: {id: status},
            trackStart: trackStart,
            trackEnd: trackEnd,
            raceStart: raceStart,
            entrys: Object.assign(entrys),
            distance: distance,
            deleted: false,
            type: type
        };
        if (id != undefined && id != null && id.length > 0) {
            race.id = id;
        }
        if(id == undefined || id == null) {
            race.entrys.forEach(entry => {
                delete entry.id;
            });
        }
        return race;
    },
    createRaceEntrys(entrys) {
        if (entrys == undefined || entrys.size == 0) {
            alert('Пробела со списком спортсменов и лодок');
            return;
        }
        let raceEntrys = [];
        for (var key of entrys.keys()) {
            let newRaceEntry = {
                competitor: entrys.get(key).competitor,
                boat: entrys.get(key).boat,
                deleted: false
            };
            if (entrys.get(key).id != undefined && entrys.get(key).id != null) {
                newRaceEntry.id = entrys.get(key).id;
            }
            raceEntrys.push(newRaceEntry);
        }
        return raceEntrys;
    },
    tableRowClassName({row, rowIndex}) {
        switch (row.type.id) {
            case 1:
                return "race-row";
            case 2:
                return "trening-row";
            case 3:
                return "track-row";
            case 4:
                return "monitoring-row";
            default:
                return "";
        }
    },
    existWayPoint(wayPoints, id) {
        return wayPoints.findIndex((wp) => {
            return wp.id === id;
        });
    },
    getTemporaryIndex(id) {
        return 'tmp_' + id;
    },
    isTemporaryIndex(id) {
        return (id + '').startsWith('tmp_');
    },
    FIXED_MARK_TYPE() {
        return 'fixed_mark';
    },
    BOAT_TYPE() {
        return 'boat';
    },
    GATE_TYPE() {
        return 'gate';
    },
    checkDateTimeRange: function (rule, value, callback) {
        if (value == undefined || value == null || value.length != 2) {
            callback(new Error('Please pick a date range'));
        }
        if (value[0] == undefined || value[0] == null) {
            callback(new Error('Please pick a date start'));
        }
        if (value[1] == undefined || value[1] == null) {
            callback(new Error('Please pick a date finish'));
        }
        let dateStart = new Date(value[0]);
        let dateFinish = new Date(value[1]);
        if (isBefore(dateFinish, dateStart)) {
            callback(new Error('date start must before finish'));
        }
        callback();
    },
    checkPhoneNumber: function (rule, value, callback) {
        if (value == undefined || value == null || value.length != 2) {
            callback(new Error('Please pick a date range'));
        }
        if (value[0] == undefined || value[0] == null) {
            callback(new Error('Please pick a date start'));
        }
        if (value[1] == undefined || value[1] == null) {
            callback(new Error('Please pick a date finish'));
        }
        let dateStart = new Date(value[0]);
        let dateFinish = new Date(value[1]);
        if (isBefore(dateFinish, dateStart)) {
            callback(new Error('date start must before finish'));
        }
        callback();
    },
    showMessage: function (vue, title, message) {
        vue.$alert(message, title, {
            confirmButtonText: 'OK'
        });
    },
    getModelSettings: function (cesium) {
        let modelSettings = {};
        modelSettings['j70.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 17.5, 0.0),
            scale: 3.5,
            animations: ['animation_0', 'animation_3', 'animation_6', 'animation_27', 'animation_30', 'animation_33']
        };
        modelSettings['j70_skolkovo.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 17.5, 0.0),
            scale: 3.5,
            animations: ['animation_0', 'animation_3', 'animation_6', 'animation_27', 'animation_30', 'animation_33']
        };
        modelSettings['m32.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 18.5, 0.0),
            scale: 1,
            animations: []
        };
        modelSettings['470.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 10.5, 0.0),
            scale: 1.8,
            animations: []
        };
        modelSettings['49er.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 11.5, 0.0),
            scale: 1.5,
            animations: []
        };
        modelSettings['boat.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 11.5, 0.0),
            scale: 2.5,
            animations: []
        };
        modelSettings['finn.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 10.5, 0.0),
            scale: 1.5,
            animations: []
        };
        modelSettings['laser.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 10.5, 0.0),
            scale: 1.5,
            animations: []
        };
        modelSettings['tornado.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(-0.5, 14.0, 0.0),
            scale: 2.5,
            animations: []
        };
        modelSettings['meldges.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 11.5, 0.0),
            scale: 2.5,
            animations: []
        };
        modelSettings['meldges1.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 11.5, 0.0),
            scale: 2.5,
            animations: []
        };
        modelSettings['mistral.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(-3.0, 8.5, 0.0),
            scale: 1.5,
            animations: []
        };
        modelSettings['output_optimist1.gltf'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(0.0, 8.5, 0.0),
            scale: 0.4,
            animations: ['animation_45', 'animation_48', 'animation_51']
        };
        modelSettings['rubber.glb'] = {
            mastEdgeCoordinates: new cesium.Cartesian3(-3.0, 2.5, 0.0),
            scale: 0.6,
            animations: []
        };

        return modelSettings;
    },
    updateEntityModel: function (entity, sportClass, cesium, viewer) {
        let scale = 3.5; // Это для буев
        let eyeOffset = new cesium.Cartesian3(0.0, 11.0, -20.0); // Это для буев
        if (Utils.getModelSettings(cesium)[sportClass.modelFileUri]) {
            scale = Utils.getModelSettings(cesium)[sportClass.modelFileUri].scale;
            eyeOffset = Utils.getModelSettings(cesium)[sportClass.modelFileUri].mastEdgeCoordinates;
        }
        entity.sportClass = sportClass;
        entity.model = {
            uri: 'models/' + sportClass.modelFileUri,
            scale: scale,
            minimumPixelSize: 15,
            shadows: window.Cesium.ShadowMode.CAST_ONLY,
            runAnimations: false
        };
        if (entity.label) {
            entity.label.eyeOffset = eyeOffset;
        }
        let _this = this;
        setTimeout(function tick() {
            //console.log('tick ...');
            try {
                let primitive = _this.getModelForEntity(entity, cesium, viewer);
                if (primitive) {
                    if (primitive.getNode('Spinnaker')) {
                        primitive.getNode('Spinnaker').show = false;
                    }
                    if (primitive.getNode('Spinnaker_mirror')) {
                        primitive.getNode('Spinnaker_mirror').show = false;
                    }
                }
            } catch (e) {
                setTimeout(tick, 300);
            }
        }, 300, _this, entity, cesium, viewer);
    },
    getModelForEntity: function (entity, cesium, viewer) {
        let primitives = viewer.scene.primitives;
        let primitive;

        for (let i = 0; i < primitives.length; i++) {
            primitive = primitives.get(i);
            if (primitive instanceof cesium.Model && primitive.id === entity) {
                return primitive;
            }
        }
    },
    raceIsTrackType: function (race) {
        return race.type.id === 3;
    },
    selectMarkOnly: function(sportClasses) {
        return this.filterSportClassByType(sportClasses, 1);
    },
    selectBoatOnly: function(sportClasses) {
        return this.filterSportClassByType(sportClasses, 3);
    },
    filterSportClassByType: function(sportClasses, type) {
        if(!Array.isArray(sportClasses)) {
            return sportClasses;
        }
        return sportClasses.filter((item) => {
            return item.type != null && item.type != undefined && item.type.id === type;
        });
    }
    // ,
    // prepareVideo: function(oldVideos, newVideos, raceId, startRaceTime) {
    //     let oldIds = [];
    //     let current = null;
    //     if(oldVideos != null && oldVideos != undefined && Array.isArray(oldVideos)) {
    //         oldIds = oldVideos.map(function(el){return el.id});
    //     }
    //     if(newVideos == null || newVideos == undefined) {
    //        if(oldIds.length > 0) {
    //            //Удалили существующие видео
    //            current = Array.from(oldVideos);
    //            current.forEach(el => {el.deleted = true;});
    //        }
    //     } else {
    //         current = Array.from(newVideos);
    //         let newIds = newVideos.filter(item => {return item.id != null && item.id != undefined;}).map(function(el){return el.id});
    //
    //         newVideos.forEach(el => {
    //             current.shift(Object.assign({}, el));
    //             if(el.id != null && el.id != undefined) {
    //                 if()
    //             }
    //         });
    //     }
    //     if(current != null) {
    //         current.forEach(el => {
    //             el.race.id = raceId;
    //             el.shiftTimeline = startRaceTime
    //         });
    //     }
    //     return current;
    // }
}

export default Utils;

